import React from 'react';
import Layout from '../components/common/Layout';
import UbicacionesList from '../components/ubicaciones/UbicacionesList';

const UbicacionesPage = () => {
    return (
        <Layout>
            <UbicacionesList />
        </Layout>
    );
};

export default UbicacionesPage;